import React, { Component } from 'react'
import { connect } from 'react-redux'
import get from 'lodash/get'
import { bindActionCreators } from 'redux'
import * as savedJobsDuck from '../savedJobsDuck'

class JobPostingErrorWrapper extends Component {
  constructor(props) {
    super(props)
    this.state = { doneDeletingSavedJob: false }
  }

  componentDidUpdate(prevProps) {
    const selectedJobPosting = get(this.props, 'selectedJobPosting')
    const savedSearchId = get(selectedJobPosting, 'savedSearchId')
    const prevSavedSearchId = get(prevProps, 'selectedJobPosting.savedSearchId')
    if (savedSearchId && savedSearchId !== prevSavedSearchId) {
      this.setState({ doneDeletingSavedJob: false })
    }

    if (prevProps.deletingSavedJob && !this.props.deletingSavedJob) {
      this.setState({ doneDeletingSavedJob: true })
    }
  }

  render() {
    const {
      children,
      jobPostingDetails,
      loadingJobPostingDetails,
      selectedJobPosting,
      performDeleteSavedJob,
      deletingSavedJob,
    } = this.props
    const error = get(jobPostingDetails, 'error')
    const savedSearchId = get(selectedJobPosting, 'savedSearchId')

    if (error && !loadingJobPostingDetails) {
      return (
        <div className="d-flex flex-column w-100">
          <div className="my-2">
            <i className="fal fa-exclamation-triangle mr-2" />
            <p style={{ display: 'inline-block' }}>This job posting is no longer active.</p>
          </div>
          {savedSearchId && (
            <div className="my-2">
              {this.state.doneDeletingSavedJob ? (
                <div>
                  <i
                    className="fal fa-check-circle mr-2"
                    style={{
                      color: '#30bc9d',
                    }}
                  />
                  <p style={{ display: 'inline-block' }} className="text-success">
                    Removed from saved jobs
                  </p>
                </div>
              ) : (
                <button
                  disabled={deletingSavedJob}
                  className="btn btn-primary px-2 w-30"
                  onClick={() => {
                    performDeleteSavedJob({ id: savedSearchId })
                  }}
                >
                  Remove from saved jobs
                </button>
              )}
            </div>
          )}
        </div>
      )
    } else {
      return children
    }
  }
}

const mapStateToProps = state => ({
  jobPostingDetails: state.jobSearch.jobPostingDetails,
  loadingJobPostingDetails: state.jobSearch.loadingJobPostingDetails,
  selectedJobPosting: state.jobSearch.selectedJobPosting,
  deletingSavedJob: state.savedJobs.deletingSavedJob,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      performDeleteSavedJob: savedJobsDuck.performDeleteSavedJob,
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(JobPostingErrorWrapper)



// WEBPACK FOOTER //
// ./src/routes/authenticated/JobSearch/components/JobPostingErrorWrapper.js